type FormattedPriceProps = {
  integerSize?: number;
  decimalSize?: number;
  color?: string;
  currency?: string;
  value: number;
  isBold?: boolean;
};

export default function FormattedPrice({
  integerSize,
  decimalSize,
  color,
  currency,
  value,
  isBold,
}: FormattedPriceProps) {
  const integerPart = Math.floor(value / 100).toString();
  const decimalPart = Math.floor(value % 100);
  const formattedIntegerPart = integerPart.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    " ",
  );

  return (
    <div
      className={`flex items-center font-jakarta text-center ${color ? `text-[${color}]` : ""} ${
        isBold ? "font-bold" : ""
      }`}
    >
      {" "}
      <span className={` ${integerSize ? `text-[${integerSize}px]` : ""}`}>
        {formattedIntegerPart}
        {decimalPart > 0 && ","}
      </span>
      {decimalPart > 0 && (
        <span className={`${decimalSize ? `text-[${decimalSize}px]` : ""}`}>
          {decimalPart}
        </span>
      )}
      {currency && (
        <span
          className={`ml-1 ${integerSize ? `text-[${integerSize}px]` : ""}`}
        >
          {currency}
        </span>
      )}
    </div>
  );
}
